<template>
  <div>
    <div>{{ $t("dashboard.failure_mode_distribution") }}</div>
    <div style="display:flex;flex-direction: row;">
      <div style="width: 50%; height: 300px" ref="chartdiv"></div>
      <div style="width: 50%; height: 300px" ref="legendDiv"></div>
    </div>
  </div>
</template>
  
<script>
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import axios from "axios";

export default {
  name: "SystemHealth_PieChart",
  props: {
    points: {
      type: Array,
      default() {
        return [];
      },
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  data() {
    return {
      series: [],
    };
  },
  methods: {
    async loadData() {
      const urlString = `${process.env.VUE_APP_APIURL}/dashboard/fault-distribution`;
      const params = {
        params: {
          start: this.startDate,
          end: this.endDate
        }
      }
      let resp = await axios.get(urlString, params);
      if (resp.status == 200) {
        this.data = resp.data;
        let chartData = [];
     
        for (let i = 0; i < this.data.length; i++) {
          let d = this.data[i];
          chartData.push({
            name: d.name[this.$i18n.locale],
            count: d["count"],
            //color: util.colorLib.getAlarmColorByOrder(d["name"]),
            id: i,
          });
        }
        // handle if no data
        if (chartData.length <= 0) {
          this.noDataLabel.set("forceHidden", false);
          this.noDataLabel.set("text", this.$t("common.noData"));
          this.series.data.setAll([]);
          this.legend.data.setAll([])
        } else {
          this.noDataLabel.set("forceHidden", true);
          this.series.labels.template.set("forceHidden", true);
          this.series.ticks.template.set("forceHidden", true);
          this.series.data.setAll(chartData);
          this.legend.data.setAll(this.series.dataItems);
        }
      } else {
        console.log("Error loading data");
      }
    },
  },
  mounted() {
    let root = am5.Root.new(this.$refs.chartdiv);
    this.root = root;
    const responsive = am5themes_Responsive.newEmpty(root)
    responsive.addRule({
      relevant: am5themes_Responsive.widthM,
      applying: function () {
        chart.set("layout", root.verticalLayout);
        // legend.setAll({
        //   y: null,
        //   centerY: null,
        //   x: am5.p0,
        //   centerX: am5.p0
        // });
      },
      removing: function () {
        chart.set("layout", root.horizontalLayout);
        legend.setAll({
          y: am5.p50,
          centerY: am5.p50,
          x: null,
          centerX: null
        });
      }
    });


    root.setThemes([responsive]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.horizontalLayout,
        width: am5.percent(75),
        centerX: am5.p50,
        x: am5.p50
      })
    );

    let series = [];
    // Create series
    series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "count",
        categoryField: "name",
        fillField: "color",
      })
    );

    // Add legend
    const legendRoot = am5.Root.new(this.$refs.legendDiv)
    this.legend = legendRoot.container.children.push(
      am5.Legend.new(legendRoot, {
        width: am5.percent(100),
        centerX: am5.percent(50),
        x: am5.percent(50),
        height: am5.percent(75),
        y: am5.p50,
        centerY: am5.p50,
        layout: legendRoot.verticalLayout,
        verticalScrollbar: am5.Scrollbar.new(legendRoot, {
          orientation: "vertical"
        })
      })
    )


    this.series = series;

    // Add label
    let noDataLabel = legendRoot.tooltipContainer.children.push(
      am5.Label.new(legendRoot, {
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: am5.p50,
        fill: am5.color("#909399"),
        fontSize: 10
      })
    );

    this.noDataLabel = noDataLabel;
    this.loadData();
  },

  beforeDestroy() {
    if (this.root) {
      this.root.dispose();
    }
  },
  watch: {
    startDate: function () {
      this.loadData();
    },
    deep: true,
  }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  width: 100%;
  height: 500px;
}
</style>